module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-418.fbb1bc3.woff2";